import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-czrz",
  "use": "icon-czrz-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-czrz\"><defs><style type=\"text/css\"></style></defs><path d=\"M756.869565 0c147.522783 0 267.130435 119.607652 267.130435 267.130435v489.73913c0 147.522783-119.607652 267.130435-267.130435 267.130435H267.130435C119.607652 1024 0 904.392348 0 756.869565V267.130435C0 119.607652 119.607652 0 267.130435 0h489.73913zM430.814609 246.205217c-44.29913-0.089043-88.486957 5.12-131.561739 15.538087l-4.006957-11.241739L244.869565 268.688696l185.945044 509.083826 50.376348-18.231652-85.48174-232.826435c80.384-53.581913 194.537739-26.802087 276.257392-66.181565C758.205217 417.947826 779.130435 299.78713 779.130435 299.78713a196.941913 196.941913 0 0 1-103.691131 23.596522c-70.455652-1.892174-153.266087-75.575652-244.624695-77.178435z\" fill=\"#F05644\" p-id=\"2859\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/czrz.svg
// module id = 8nvf
// module chunks = 1